import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { capatelize } from 'src/app/SEO_Constant/routes.constant';
import { description, keyword } from 'src/app/SEO_Constant/seo';

@Component({
    selector: 'app-digital-media-marketing',
    templateUrl: './digital-media-marketing.component.html',
    styleUrls: ['./digital-media-marketing.component.css'],
    standalone: false
})
export class DigitalMediaMarketingComponent implements OnInit {
  titles:any;
  bannerArray:any = {
    "bannerTXT" : [
      {
        title: 'Digital marketing realize your company`s growth potential.',
      },
      {
        title: 'Digital marketing includes email, social media, and web-based advertising etc.',
      },
      {
        title: 'Digital marketing promote products and services on digital channels.',
      },
      {
        title: 'More Visibility, More Leads, More Business.',
      },
    ],
    "bannerImg" : {
      "banner": "assets/img/Digital_Media.png",
      "backgroundImg": "assets/img/banner-background.jpg"
    }
  }
  constructor(private title: Title, private meta: Meta, private router:Router,@Inject(PLATFORM_ID) private platformId: Object) {
    this.titles = router.url.split('/')[router.url.split('/').length-1].replace(/-/g,' ')
  }

  ngOnInit(): void {
    let currentUrl='';
    if (isPlatformBrowser(this.platformId)) {
      currentUrl = window.location.origin + this.router.url;
    }
    this.title.setTitle(
      capatelize(this.titles) +' | Resiliencesoft'
    );
    this.meta.removeTag('name=description');
    this.meta.removeTag('name=keywords');
    this.meta.addTags([
      {
        name: 'description',
        content: description.DigitalMediaMarketing,
      },
      {
        name: 'keywords',
        content: capatelize(keyword.globle) + capatelize(keyword.DigitalMediaMarketing),
      },
    ]);

     // --- Open Graph Meta ---
    this.meta.addTags([
      { property: 'og:type', content: 'webapp' },
      { property: 'og:title', content: capatelize(this.titles) },
      {
        property: 'og:description',
        content: description.DigitalMediaMarketing,
      },
      { property: 'og:url', content: currentUrl  },
      {
        property: 'og:image',
        content: 'https://www.resiliencesoft.com/assets/images/logo.webp',
      },
      { property: 'og:image:alt', content: 'RESILIENCESOFT Logo' },
      { property: 'og:site_name', content: 'RESILIENCESOFT' },
      { property: 'og:locale', content: 'en_US' },
    ]);

      // --- Twitter Card Meta ---
    this.meta.addTags([
      { name: 'twitter:card', content: 'RESILIENCESOFT' },
      { name: 'twitter:title', content: capatelize(this.titles) },
      {
        name: 'twitter:description',
        content: description.DigitalMediaMarketing,
      },
      {
        name: 'twitter:image',
        content: 'https://www.resiliencesoft.com/assets/images/logo.webp',
      },
      { name: 'twitter:site', content: 'https://x.com/ResilienceSoft1' },
    ]);
  }
}
